@if (errorVisible) {
    @for (message of messageConfig; track message) {
        @if (input?.errors && input?.errors?.[message.code]) {
            <span class="m-0 message-mat-error"> {{ message.message }} </span>
        }
    }
}
